/* idags slide-out cart: intercepts add-to-cart forms inside idags sections,
   re-renders the ix-cart-drawer section and slides it in from the right. */
(() => {
  const drawer = document.querySelector('[data-ix-drawer]');
  if (!drawer) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const panel = drawer.querySelector('.drawer-panel');
  let lastFocus = null;

  const open = () => {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ix-lock');
    panel.focus({ preventScroll: true });
  };
  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ix-lock');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  const setCount = (n) => {
    document.querySelectorAll('[data-ix-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = Number(n) === 0;
    });
  };

  const refresh = async () => {
    const html = await fetch(`${root}?section_id=ix-cart-drawer`).then((r) => r.text());
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ix-drawer-inner]');
    const current = drawer.querySelector('[data-ix-drawer-inner]');
    if (next && current) {
      current.replaceWith(next);
      setCount(next.dataset.count);
    }
  };

  drawer.addEventListener('click', async (e) => {
    if (e.target.closest('[data-ix-drawer-close]')) return close();
    const change = e.target.closest('[data-ix-change]');
    if (!change) return;
    drawer.classList.add('is-busy');
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.qty) }),
    });
    await refresh();
    drawer.classList.remove('is-busy');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-ix-cart-open]');
    if (!trigger || location.pathname.endsWith('/cart')) return;
    e.preventDefault();
    open();
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.closest('.ix') || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    e.preventDefault();
    const button = e.submitter || form.querySelector('[type="submit"]');
    const label = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.textContent = (window.ixStrings && window.ixStrings.adding) || 'Adding…'; }
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || (window.ixStrings && window.ixStrings.addError) || 'Could not add to bag. Please try again.');
      }
      try { sessionStorage.setItem('ix-carted', '1'); } catch (_) {}
      await refresh();
      open();
    } catch (err) {
      let msg = form.querySelector('.form-error');
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'form-error';
        form.appendChild(msg);
      }
      msg.textContent = err.message;
    } finally {
      if (button) { button.disabled = false; button.innerHTML = label; }
    }
  });
})();

/* Popup guard: Klaviyo's page rules only see URLs, so keep its sign-up popup out of the way
   of shopping. With something in the bag it stays hidden for the visit; over an open, empty
   drawer it waits until the drawer closes. Klaviyo ignores scripted clicks on its close button,
   so the popup is hidden with a class (see idags.css) rather than dismissed. */
(() => {
  const drawer = document.querySelector('[data-ix-drawer]');
  const root = document.documentElement;

  const hasBag = () => {
    try { if (sessionStorage.getItem('ix-carted') === '1') return true; } catch (_) {}
    const inner = document.querySelector('[data-ix-drawer-inner]');
    return /\/cart\/?$/.test(location.pathname) || Number(inner && inner.dataset.count) > 0;
  };
  const drawerOpen = () => !!(drawer && drawer.classList.contains('is-open'));
  const sync = () => root.classList.toggle('ix-popup-hide', hasBag() || drawerOpen());

  // The class only ever affects the popup overlay, so it is safe to keep it in sync at all times.
  window.addEventListener('klaviyoForms', sync);
  if (drawer) new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  sync();
})();
